import React, { type FC } from "react";
import { sanitize } from "../utils/sanitizer";

type SanitizedRendererProps = {
    html: SanitizedString;
    as?: React.ElementType;
} & React.HTMLProps<HTMLDivElement>;

type UnsanitizedRendererProps = {
    html: string;
    as?: React.ElementType;
} & React.HTMLProps<HTMLDivElement>;

// eslint-disable-next-line id-length
const SanitizedRenderer: FC<SanitizedRendererProps> = ({ html = "", as = "span", ...props }) => {
    const Tag = as;
    return <Tag {...props} dangerouslySetInnerHTML={{ __html: html }} />;
};

// eslint-disable-next-line id-length
export const UnsanitizedRenderer: FC<UnsanitizedRendererProps> = ({ html = "", as = "span", ...props }) => {
    const sanitizedHtml = sanitize(html);
    return <SanitizedRenderer html={sanitizedHtml} as={as} {...props} />;
};

export default SanitizedRenderer;
